import { useMe } from "@/api/hooks/auth";

import { APP_HOME } from "./nav-config";

/** Where "home" is for the current visitor: the app when signed in, the landing page otherwise. */
export function useHomePath(): string {
  return useMe() ? APP_HOME : "/";
}
